import './header.css';
import Logo from '../../images/logo.png'
import ModalConfirm from '../modais/ModalConfirm';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as IconeSair } from '../../assets/icones/logout.svg';
import { useDispatch } from 'react-redux';
import { logout } from '../../features/auth/logoutSlice';
import { Fragment, useState } from 'react';
import { useStoreContext } from '../../hooks/context/StoreContext';

const Header = ({ titulo }) => {
    const {
        modal,
        setModal
    } = useStoreContext();

    const [apiCarregando, setApiCarregando] = useState(false);

    const btnLogout = () => {
        setModal(prev => ({
            ...prev,
            identificadorModalConfirm: 'logout',
            openModalConfirm: true,
            tituloModalConfirm: 'Atenção',
            subtituloModalConfirm: 'Tem certeza que deseja sair?',
            textoModalConfirm: '',
        }));
    };

    const handleLogout = async () => {
        setApiCarregando(true);

        try {
            setModal(prev => ({
                ...prev,
                identificadorModalConfirm: '',
                openModalConfirm: false,
                subtituloModalConfirm: '',
                textoModalConfirm: '',
            }));

        } catch (error) {
            console.log(error)
        } finally {
            setApiCarregando(false);
        };
    };

    return (
        <Fragment>
            <header className='container-header'>
                <div className='header-logo'>
                    <img src={Logo} alt='Logo OG1' title='Logo OG1' width='75px' />
                    <h3>{titulo}</h3>
                </div>
                <div
                    tabIndex={0}
                    className='container-logout'
                    onClick={() => btnLogout()}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            btnLogout();
                        };
                    }}
                >
                    <IconeSair
                        width={'22px'}
                        fill={'#212121'}
                        fillOpacity={'0.8'}
                    />
                    <span className='logout-text'>Sair</span>
                </div>
            </header>
            <ModalConfirm
                isOpen={modal.openModalConfirm}
                closeModal={() => setModal(prev => ({ ...prev, openModalConfirm: false }))}
                titulo={modal.tituloModalConfirm}
                primeiroTexto={modal.subtituloModalConfirm}
                segundoTexto={modal.textoModalConfirm}
                confirm={() => handleLogout()}
                loading={apiCarregando}
            />
        </Fragment>
    );
};

export default Header;